/**
 * Client Call Type for client to make call w.r.t. audio, video, presentation direction
 */
export var ClientCallType;
(function (ClientCallType) {
    /**
     * Client to join as a control-only participant, i.e. the
     * user will not send or receive any audio or video. They
     * can still access the conference controls.
     */
    ClientCallType[ClientCallType["None"] = 0] = "None";
    /**
     * Join as a sending-audio-only participant, not receiving
     * any audio, also will not send or receive video.
     */
    ClientCallType[ClientCallType["AudioSend"] = 2] = "AudioSend";
    /**
     * Join as a receiving-audio-only participant, not sending
     * any audio, also will not send or receive video.
     */
    ClientCallType[ClientCallType["AudioRecv"] = 4] = "AudioRecv";
    /**
     * Join as a sending-video-only participant, not receiving
     * any video, also will not send or receive audio.
     */
    ClientCallType[ClientCallType["VideoSend"] = 8] = "VideoSend";
    /**
     * Join as a receiving-video-only participant, not sending
     * any video, also will not send or receive audio.
     */
    ClientCallType[ClientCallType["VideoRecv"] = 16] = "VideoRecv";
    /**
     * Join as a sending-presentation-only participant.
     */
    ClientCallType[ClientCallType["PresentationSend"] = 32] = "PresentationSend";
    /**
     * Join as a receiving-presentation-only participant.
     */
    ClientCallType[ClientCallType["PresentationRecv"] = 64] = "PresentationRecv";
    /**
     * Join as an audio-only participant, i.e. the user will send and receive
     * audio but will not send or receive video.
     */
    ClientCallType[ClientCallType["AudioSendRecv"] = 6] = "AudioSendRecv";
    /**
     * Join as a video-only participant, i.e. the user will send and receive
     * video but will not send or receive audio.
     */
    ClientCallType[ClientCallType["VideoSendRecv"] = 24] = "VideoSendRecv";
    /**
     * Join as a presentation only participant
     */
    ClientCallType[ClientCallType["PresentationSendRecv"] = 96] = "PresentationSendRecv";
    ClientCallType[ClientCallType["AudioRecvPresentationSendRecv"] = 100] = "AudioRecvPresentationSendRecv";
    ClientCallType[ClientCallType["AudioSendPresentationSendRecv"] = 98] = "AudioSendPresentationSendRecv";
    ClientCallType[ClientCallType["VideoRecvPresentationSendRecv"] = 112] = "VideoRecvPresentationSendRecv";
    ClientCallType[ClientCallType["VideoSendPresentationSendRecv"] = 104] = "VideoSendPresentationSendRecv";
    /**
     * Join as a sending-audio-video-only participant, i.e. the user will only
     * send audio and video but will not receive audio or video.
     */
    ClientCallType[ClientCallType["AudioSendVideoSend"] = 10] = "AudioSendVideoSend";
    /**
     * Join as a sending-audio-video-presentation-only participant, i.e. the
     * user will only send audio, video, and presentation but will not
     * receive audio, video, or presentation.
     */
    ClientCallType[ClientCallType["AudioSendVideoSendPresentationSend"] = 42] = "AudioSendVideoSendPresentationSend";
    /**
     * Join as a receiving-audio-video-only participant, i.e. the user will only
     * receive audio and video but will not send audio or video.
     */
    ClientCallType[ClientCallType["AudioRecvVideoRecv"] = 20] = "AudioRecvVideoRecv";
    /**
     * Join as a receiving-audio-video-presentation-only participant, i.e. the
     * user will only receive audio, video, and presentation but will not send
     * audio, video, or presentation.
     */
    ClientCallType[ClientCallType["AudioRecvVideoRecvPresentationRecv"] = 84] = "AudioRecvVideoRecvPresentationRecv";
    ClientCallType[ClientCallType["AudioRecvVideoRecvPresentationSendRecv"] = 116] = "AudioRecvVideoRecvPresentationSendRecv";
    ClientCallType[ClientCallType["AudioSendVideoSendPresentationSendRecv"] = 106] = "AudioSendVideoSendPresentationSendRecv";
    /**
     * Join as a full (send and receive) audio and presentation participant
     */
    ClientCallType[ClientCallType["AudioSendRecvPresentationSendRecv"] = 102] = "AudioSendRecvPresentationSendRecv";
    /**
     * Join as a full (send and receive) video and presentation participant
     */
    ClientCallType[ClientCallType["VideoSendRecvPresentationSendRecv"] = 120] = "VideoSendRecvPresentationSendRecv";
    /**
     * Join as a full (send and receive) audio and video participant
     */
    ClientCallType[ClientCallType["AudioSendRecvVideoSendRecv"] = 30] = "AudioSendRecvVideoSendRecv";
    /**
     * Join as a full (send and receive) audio, video, and presentation participant
     */
    ClientCallType[ClientCallType["AudioSendRecvVideoSendRecvPresentationSendRecv"] = 126] = "AudioSendRecvVideoSendRecvPresentationSendRecv";
    ClientCallType[ClientCallType["AudioSendVideoRecv"] = 18] = "AudioSendVideoRecv";
    ClientCallType[ClientCallType["AudioRecvVideoSend"] = 12] = "AudioRecvVideoSend";
    ClientCallType[ClientCallType["AudioSendVideoRecvPresentationSendRecv"] = 114] = "AudioSendVideoRecvPresentationSendRecv";
    ClientCallType[ClientCallType["AudioRecvVideoSendPresentationSendRecv"] = 108] = "AudioRecvVideoSendPresentationSendRecv";
    ClientCallType[ClientCallType["AudioSendVideoSendPresentationRecv"] = 74] = "AudioSendVideoSendPresentationRecv";
    ClientCallType[ClientCallType["AudioRecvVideoRecvPresentationSend"] = 52] = "AudioRecvVideoRecvPresentationSend";
    ClientCallType[ClientCallType["AudioSendPresentationSend"] = 34] = "AudioSendPresentationSend";
    ClientCallType[ClientCallType["AudioSendPresentationRecv"] = 66] = "AudioSendPresentationRecv";
    ClientCallType[ClientCallType["AudioRecvPresentationSend"] = 36] = "AudioRecvPresentationSend";
    ClientCallType[ClientCallType["AudioRecvPresentationRecv"] = 68] = "AudioRecvPresentationRecv";
    ClientCallType[ClientCallType["VideoSendPresentationSend"] = 40] = "VideoSendPresentationSend";
    ClientCallType[ClientCallType["VideoSendPresentationRecv"] = 72] = "VideoSendPresentationRecv";
    ClientCallType[ClientCallType["VideoRecvPresentationSend"] = 48] = "VideoRecvPresentationSend";
    ClientCallType[ClientCallType["VideoRecvPresentationRecv"] = 80] = "VideoRecvPresentationRecv";
    ClientCallType[ClientCallType["AudioSendRecvVideoSendRecvPresentationSend"] = 62] = "AudioSendRecvVideoSendRecvPresentationSend";
    ClientCallType[ClientCallType["AudioSendRecvVideoSendRecvPresentationRecv"] = 94] = "AudioSendRecvVideoSendRecvPresentationRecv";
    // Complete list of 64 combinations (bitmask from 0 to 63)
    // Already defined above, but for completeness, here are all possible combinations:
    ClientCallType[ClientCallType["AudioSendVideoRecvPresentationSend"] = 50] = "AudioSendVideoRecvPresentationSend";
    ClientCallType[ClientCallType["AudioSendVideoRecvPresentationRecv"] = 82] = "AudioSendVideoRecvPresentationRecv";
    ClientCallType[ClientCallType["AudioRecvVideoSendPresentationSend"] = 44] = "AudioRecvVideoSendPresentationSend";
    ClientCallType[ClientCallType["AudioRecvVideoSendPresentationRecv"] = 76] = "AudioRecvVideoSendPresentationRecv";
    // All send/recv combinations for each media type
    ClientCallType[ClientCallType["AudioSendVideoSendRecv"] = 26] = "AudioSendVideoSendRecv";
    ClientCallType[ClientCallType["AudioSendRecvVideoSend"] = 14] = "AudioSendRecvVideoSend";
    ClientCallType[ClientCallType["AudioSendRecvVideoRecv"] = 22] = "AudioSendRecvVideoRecv";
    ClientCallType[ClientCallType["AudioSendVideoSendRecvPresentationSend"] = 58] = "AudioSendVideoSendRecvPresentationSend";
    ClientCallType[ClientCallType["AudioSendVideoSendRecvPresentationRecv"] = 90] = "AudioSendVideoSendRecvPresentationRecv";
    ClientCallType[ClientCallType["AudioSendRecvVideoSendPresentationSend"] = 46] = "AudioSendRecvVideoSendPresentationSend";
    ClientCallType[ClientCallType["AudioSendRecvVideoSendPresentationRecv"] = 78] = "AudioSendRecvVideoSendPresentationRecv";
    ClientCallType[ClientCallType["AudioSendRecvVideoRecvPresentationSend"] = 54] = "AudioSendRecvVideoRecvPresentationSend";
    ClientCallType[ClientCallType["AudioSendRecvVideoRecvPresentationRecv"] = 86] = "AudioSendRecvVideoRecvPresentationRecv";
    // All combinations with PresentationSendRecv
    ClientCallType[ClientCallType["AudioSendVideoSendRecvPresentationSendRecv"] = 122] = "AudioSendVideoSendRecvPresentationSendRecv";
    ClientCallType[ClientCallType["AudioRecvVideoSendRecvPresentationSendRecv"] = 124] = "AudioRecvVideoSendRecvPresentationSendRecv";
    ClientCallType[ClientCallType["AudioSendRecvVideoSendPresentationSendRecv"] = 110] = "AudioSendRecvVideoSendPresentationSendRecv";
    ClientCallType[ClientCallType["AudioSendRecvVideoRecvPresentationSendRecv"] = 118] = "AudioSendRecvVideoRecvPresentationSendRecv";
    // All combinations with AudioSendRecv
    ClientCallType[ClientCallType["AudioSendRecvPresentationSend"] = 38] = "AudioSendRecvPresentationSend";
    ClientCallType[ClientCallType["AudioSendRecvPresentationRecv"] = 70] = "AudioSendRecvPresentationRecv";
    // All combinations with VideoSendRecv
    ClientCallType[ClientCallType["VideoSendRecvPresentationSend"] = 56] = "VideoSendRecvPresentationSend";
    ClientCallType[ClientCallType["VideoSendRecvPresentationRecv"] = 88] = "VideoSendRecvPresentationRecv";
    ClientCallType[ClientCallType["AudioRecvVideoSendRecv"] = 28] = "AudioRecvVideoSendRecv";
    ClientCallType[ClientCallType["AudioRecvVideoSendRecvPresentationSend"] = 60] = "AudioRecvVideoSendRecvPresentationSend";
    ClientCallType[ClientCallType["AudioRecvVideoSendRecvPresentationRecv"] = 92] = "AudioRecvVideoSendRecvPresentationRecv";
})(ClientCallType || (ClientCallType = {}));
export const CLIENT_CALL_TYPE_MAP = new Map(Object.entries(ClientCallType).flatMap(([k, v]) => typeof v === 'number' ? [[k.toLowerCase(), v]] : []));
